import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { getLegacyInsiderPlusPath } from '../../util/helpers/insiderPlusPathHelper';

// Old /insider-plus and /insider-plus-membership URLs → the Investor Hub path,
// keeping any sub-path, query string and hash. Covers navigation inside the
// running app (e.g. the Insider+ iframe asking the parent to go to
// /insider-plus-membership), which never passes through index.js's
// normalizeLegacyInsiderPlusUrl.
const LegacyInsiderPlusRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const target = getLegacyInsiderPlusPath(pathname);

  if (!target) return null;

  return <Redirect to={{ pathname: target, search, hash }} />;
};

export default LegacyInsiderPlusRedirect;
